import type { FieldValues } from 'react-hook-form';

import type { Countries } from '@ctct/domain-layer';

import { CountriesService } from './services/CountriesService';
import { FormChangeHandlerService } from './services/FormChangeHandlerService';
import { TranslationService } from './services/TranslationService';
import { UIService } from './services/UIService';
import { ValidationService } from './services/ValidationService';
import type { BaseFormEvents } from './types';
import type { EventBus } from '../../../helpers';
import type { TranslationGetter } from '../../../types';

export class FormServiceFactory {
  static createCountriesService(countries: Countries, t: TranslationGetter): CountriesService {
    return new CountriesService(countries, t);
  }

  static createFormChangeHandlerService<T extends FieldValues>(
    countries: Countries,
    eventBus: EventBus<BaseFormEvents<T>>,
    setIsDirty: (isDirty: boolean) => void,
    handleClearErrors: () => void
  ): FormChangeHandlerService<T> {
    return new FormChangeHandlerService(countries, eventBus, setIsDirty, handleClearErrors);
  }

  static createTranslationService(t: TranslationGetter): TranslationService {
    return new TranslationService(t);
  }

  static createUIService<T extends FieldValues>(
    getIsDisplayingCard: () => boolean,
    getIsDirty: () => boolean,
    setIsDirty: (isDirty: boolean) => void,
    setIsDisplayingCard: (isDisplayingCard: boolean) => void,
    setIsLoading: (isLoading: boolean) => void,
    eventBus: EventBus<BaseFormEvents<T>>
  ): UIService<T> {
    return new UIService<T>(getIsDisplayingCard, getIsDirty, setIsDirty, setIsDisplayingCard, setIsLoading, eventBus);
  }

  static createValidationService(countries: Countries, t: TranslationGetter): ValidationService {
    return new ValidationService(countries, t);
  }
}
